module.exports = __webpack_public_path__ + "img/insurance-umbrella.e4f6675a.svg";